import LodgeBirdsSelect from './LodgeBirdsSelect';

export default LodgeBirdsSelect;
